import {
    ableProps,
    ablePropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';
export const props = () => [
    ...ableProps,
    ...validatorProps,
    {
        key: 'align',
        label: '对齐位置',
        type: 'enum',
        collection: [
            {
                label: 'left',
                value: 'left',
            },
            {
                label: 'right',
                value: 'right',
            },
        ],
    },
    {
        key: 'mustTrue',
        label: '必须勾选',
        type: 'boolean',
    },
    {
        key: 'errMustTrue',
        label: '未勾选提示文案',
        type: 'string',
    },
    {
        key: 'descEditor',
        label: '文案配置',
        type: 'editor',
        menuList,
    },
];

export const init = () => ({
    ...ablePropsInit,
    ...validatorPropsInit,
    align: 'left',
    mustTrue: false,
    errMustTrue: '',
    descEditor: '协议名称',
});

export const name = '协议';

export const component = 'mobile-general-form-agreement';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];

export const menuList = [
    'undo',
    'redo',
    'bold',
    'link',
];